const classes = {
  wrapper: 'flex flex-col grow-0 w-full md:w-4/12 md:shrink-0',
  content: 'px-4 md:px-0 gap-10',
  input: 'mb-10',
  group: 'flex flex-col gap-6',
  facet: 'flex flex-col flex-wrap gap-2 mb-10',
} as const;

export default classes;
